import script from "./CustomDashboardTableHeaderCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardTableHeaderCell.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardTableHeaderCell.vue?vue&type=style&index=0&id=5ead95e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ead95e9"]])

export default __exports__